import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import { fadeStyle } from 'src/components/NewRenterInterface/constants';

interface HouseholdConfirmContinueViewProps {
  propertyName: string | null;
  onNext: () => void;
}

const HouseholdConfirmContinueView: FC<HouseholdConfirmContinueViewProps> = ({
  propertyName,
  onNext,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 280,
      gap: 2,
      ...fadeStyle,
    }}
  >
    <HomeWorkIcon sx={{ fontSize: 72, color: 'text.secondary' }} />
    <Typography variant="h6" fontWeight={600} align="center">
      Continue to confirm Household
      {propertyName ? ` for ${propertyName}` : ''}
    </Typography>
    <Button variant="contained" size="large" onClick={onNext} sx={{ mt: 1 }}>
      Next
    </Button>
  </Box>
);

export default HouseholdConfirmContinueView;
